export default (el) => {
  el.addEventListener('input', () => autoresize(el))
  autoresize(el)
}

function autoresize(el) {
  el.style.height = ''
  const height = el.scrollHeight + 10
  el.style.height = `${height}px`
}
